
import { defineComponent, ref } from '@vue/composition-api';

export default defineComponent({
  name: 'Pagination',
  props: {
    total: {
      type: Number,
      required: true,
      default: 0,
    },
    size: {
      type: Number,
      required: false,
      default: 10,
    },
  },
  emits: ['goToPrevious', 'goToNext'],
  setup(props, { emit }) {
    const currentPage = ref<number>(0);

    const calcPage = (): number => {
      return Math.ceil(props.total / props.size);
    };

    const goToPrevious = (page: number) => {
      if (page === 0) {
        return;
      }

      currentPage.value = currentPage.value - 1;
      emit('goToPrevious', currentPage.value);
    };

    const onChangePage = (page: number) => {
      currentPage.value = page;
      emit('goToPrevious', currentPage.value);
    };

    const goToNext = (page: number) => {
      const totalPage = Math.ceil(props.total / props.size);

      if (page === totalPage - 1) {
        return;
      }

      currentPage.value = currentPage.value + 1;
      emit('goToNext', currentPage.value);
    };

    return {
      currentPage,
      calcPage,
      goToPrevious,
      onChangePage,
      goToNext,
    };
  },
});
